<!-- Every message shares one grid cell, so the cell is always sized to the longest one -->
<div class="rotating-title">
  <span
    *ngFor="let message of messages; let i = index"
    class="rotating-title__line"
    [class.is-active]="i === activeIndex"
    [class.is-leaving]="i === previousIndex"
    [attr.aria-hidden]="i !== activeIndex"
    >{{ message | translate }}</span
  >
</div>
